import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { majorsGuideContent } from '../content';

const dataSourcesDetail = [
  `${majorsGuideContent.dataSources.title}: ${majorsGuideContent.dataSources.subtitle}`,
  `${majorsGuideContent.dataSources.sectionTitle}: ${majorsGuideContent.dataSources.sources.map((s) => `${s.name} (${s.description})`).join('; ')}.`,
  `${majorsGuideContent.dataSources.aiIntegrationTitle}: ${majorsGuideContent.dataSources.aiIntegration}`,
  majorsGuideContent.dataSources.commitment,
].join('\n');

const majors101 = majorsGuideContent.majors101;
const majors101Detail = [
  `${majors101.title}: ${majors101.subtitle}`,
  `College Major: ${majors101.collegeDefinition.description} (e.g. ${majors101.collegeDefinition.examples.join(', ')})`,
  `Career Path: ${majors101.careerDefinition.description} (e.g. ${majors101.careerDefinition.examples.join(', ')})`,
  `${majors101.keyDifference.title}: ${majors101.keyDifference.summary}`,
  ...(majors101.keyDifference.paragraphs ?? []),
  `${majors101.keyDifference.connectionTitle}: ${majors101.keyDifference.connectionDescription}`,
  ...(majors101.relationshipsV2 ?? []).map(
    (r) =>
      `${r.type}: ${r.description} Examples: ${r.examples.map((e) => `${e.major} → ${e.career}`).join(', ')}.`,
  ),
].join('\n');

const faqDetail = majorsGuideContent.faqSections
  .map((faq) =>
    [
      faq.title,
      faq.content.intro,
      ...faq.content.subsections.map((s) => `${s.heading}: ${s.content}`),
      ...(faq.content.bottomLine ? [`Bottom Line: ${faq.content.bottomLine}`] : []),
    ].join('\n'),
  )
  .join('\n\n');

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Overview',
    description: 'Introductory section about why choosing the right major matters.',
    detail: majorsGuideContent.header.description.join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Major Tools',
    description:
      'Cards linking to the Majors-Careers explorer, Explore Majors search, Careers-to-Majors explorer, and Pick a Major.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Majors vs Career Paths',
    description:
      'Inline Majors 101 section explaining key differences between majors and career paths, with relationship categories.',
    detail: majors101Detail,
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Majors by College',
    description:
      'Accordion list of all majors grouped by college type (e.g. Business, Engineering, Arts & Sciences). Users can expand each college to see its majors.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Majors FAQs',
    description:
      'Detailed FAQ topics about college majors, careers, admissions, and outcomes. The section header also exposes a "Where do we get our data?" dialog covering sources and methodology.',
    detail: [faqDetail, '', 'Data Sources:', dataSourcesDetail].join('\n'),
  });
};
